/** What the canvas and the panels on its right side show. */
export enum LBCanvasMode {
  /** The Editor tab, with the live graph. */
  EDITING = 'EDITING',
  /** The Editor tab, with the live graph and the test panel's setup form. */
  TEST_SETUP = 'TEST_SETUP',
  /** The Editor tab, with the viewed test run's graph and its steps in the test panel. */
  TEST_RESULTS = 'TEST_RESULTS',
  /** The Runs tab, with the viewed run's graph and the Runs panel. */
  RUNS = 'RUNS',
}
